import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setSelectedKeys, setTriggerNdaLeave } from 'store/slices/windowStateSlice';
import classes from './NDASection.module.scss';
import AccessTerms from './AccessTerms/AccessTerms';
import RoomAccess from './RoomAccess/RoomAccess';
import RelatedRooms from './RelatedRooms/RelatedRooms';
import { setDocuments } from 'store/slices/dataDocumentsSlice';
import { IDocument } from 'interfaces';

const NDASection = () => {
  const [activeTerms, setActiveTerms] = React.useState<IDocument[]>([]);
  
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { userPermissions } = useAppSelector((state) => state.userData);

  const relatedRef = React.useRef<HTMLDivElement | null>(null);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(setSelectedKeys(['nda']));
  }, [dataRoom?.agreement_file]);

  React.useEffect(() => {    
    dispatch(setDocuments({documents: [], folders: []}));
    return () => {
      dispatch(setTriggerNdaLeave(true));
      localStorage.removeItem('scrollToRelatedRooms');
    };
  }, []);

  React.useEffect(() => {
    const needToScroll = localStorage.getItem('scrollToRelatedRooms') === 'true';    
    if (relatedRef.current && needToScroll) relatedRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [relatedRef.current, activeTerms.length]);

  return (
    <div className={classes.confirm}>
      <AccessTerms setActiveTerms={setActiveTerms} activeTerms={activeTerms}/>
      {(dataRoom?.agreement_enable || userPermissions?.can_edit_room_settings) && <RoomAccess />}
      {dataRoom && dataRoom?.user_status !== 1 && dataRoom?.access_terms_status !== 'waiting_for_approve' && (
        <RelatedRooms relatedRef={relatedRef}/>
      )}
    </div>
  );
};

export default NDASection;
